import { render, staticRenderFns } from "./payfor-refund-add.vue?vue&type=template&id=0a53d724&"
import script from "./payfor-refund-add.vue?vue&type=script&lang=js&"
export * from "./payfor-refund-add.vue?vue&type=script&lang=js&"
import style0 from "./payfor-refund-add.vue?vue&type=style&index=0&id=0a53d724&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports